import { CardEnum, CardProps } from './types';
import { StationCard } from './StationCard/StationCard';
import { StationCardTypes } from './StationCard/types';
import { StationDetailCard } from './StationDetailCard/StationDetailCard';
import { StationDetailCardTypes } from './StationDetailCard/types';
import { UserSessionCard } from './UserSessionCard/UserSessionCard';
import { UserTransactionCard } from './UserTransactionCard/UserTransactionCard';
import { SessionType } from './UserSessionCard/types';
import { TransactionType } from './UserTransactionCard/types';

export const Card: React.FC<CardProps> = ({ type, data }) => {
  switch (type) {
    case CardEnum.Station_card:
      return <StationCard data={data as StationCardTypes} />;
    case CardEnum.Direction_to_station_card:
      return <StationDetailCard data={data as StationDetailCardTypes} />;
    case CardEnum.User_Session_card:
      return <UserSessionCard data={data as SessionType} />;
    case CardEnum.User_transaction_card:
      return <UserTransactionCard data={data as TransactionType} />;
    default:
      return null;
  }
};
